import {
    INVENTORY_FIND_PRODUCTS_FAILURE,
    INVENTORY_FIND_PRODUCTS_REQUEST,
    INVENTORY_FIND_PRODUCTS_SUCCESS,
    INVENTORY_SAVE_STOCKTAKING_FAILURE,
    INVENTORY_SAVE_STOCKTAKING_REQUEST,
    INVENTORY_SAVE_STOCKTAKING_SUCCESS,
    INVENTORY_INIT_FAILURE,
    INVENTORY_INIT_REQUEST,
    INVENTORY_INIT_SUCCESS,
    INVENTORY_NEW_SEARCH,
    INVENTORY_RESET,
    INVENTORY_NEW_UNSAVED_CHANGE,
    INVENTORY_UPDATE_PRODUCT_FAILURE,
    INVENTORY_UPDATE_PRODUCT_REQUEST,
    INVENTORY_UPDATE_PRODUCT_SUCCESS,
    INVENTORY_LOAD_STOCK_TAKING_IN_PROGRESS_FAILURE,
    INVENTORY_LOAD_STOCK_TAKING_IN_PROGRESS_REQUEST,
    INVENTORY_LOAD_STOCK_TAKING_IN_PROGRESS_SUCCESS
} from "./actions";

const initialState = {
    warehouse: null,
    status: null,
    stockTakingsInProgress: [],
    stock_taking_id: null,
    init: false,
    isLoading: false,
    products: null,
    unsavedChanges: {}
};

// -----------------------------------------------------------------------------
// REDUCER

export default (state = initialState, action) => {

    switch (action.type) {

        case INVENTORY_RESET:
            return initialState;
        case INVENTORY_INIT_REQUEST:
        case INVENTORY_FIND_PRODUCTS_REQUEST:
        case INVENTORY_UPDATE_PRODUCT_REQUEST:
        case INVENTORY_LOAD_STOCK_TAKING_IN_PROGRESS_REQUEST:
        case INVENTORY_SAVE_STOCKTAKING_REQUEST:

            return {
                ...state,
                isLoading: true
            };

        case INVENTORY_INIT_FAILURE:
        case INVENTORY_FIND_PRODUCTS_FAILURE:
        case INVENTORY_UPDATE_PRODUCT_FAILURE:
        case INVENTORY_LOAD_STOCK_TAKING_IN_PROGRESS_FAILURE:
        case INVENTORY_SAVE_STOCKTAKING_FAILURE:
        case INVENTORY_SAVE_STOCKTAKING_SUCCESS:

            return {
                ...state,
                isLoading: false
            };

        case INVENTORY_INIT_SUCCESS:

            return {
                ...state,
                isLoading: false,
                init: true,
                stock_taking_id: action.stockTaking.id,
                warehouse: action.stockTaking.warehouse,
                status: action.stockTaking.status
            };

        case INVENTORY_FIND_PRODUCTS_SUCCESS:

            return {
                ...state,
                products: action.products,
                isLoading: false
            };

        case INVENTORY_NEW_SEARCH:

            return {
                ...state,
                products: null,
                unsavedChanges: {}
            };

        case INVENTORY_NEW_UNSAVED_CHANGE:

            let newUnsavedChanges = {...state.unsavedChanges};
            newUnsavedChanges[action.id] = true;

            return {
                ...state,
                unsavedChanges: newUnsavedChanges,
            };



        case INVENTORY_UPDATE_PRODUCT_SUCCESS:

            delete state.unsavedChanges[action.observation.productID];

            return {
                ...state,
                isLoading: false,
                products: state.products.map((product)=>{
                    if(action.observation.productID && product.productID === action.observation.productID){
                        product.count = action.observation.count;
                        product.comment = action.observation.comment;
                        product.counted = action.observation.counted;
                    }
                    return product;
                })

            };

        case INVENTORY_LOAD_STOCK_TAKING_IN_PROGRESS_SUCCESS:

            return {
                ...state,
                isLoading: false,
                stockTakingsInProgress: action.stockTakings
            };



        default:
            return state
    }
}

// -----------------------------------------------------------------------------
// PRIVATE SELECTORS

export function isLoading(store) {
    return store.isLoading;
}

export function isInit(store) {
    return store.init;
}

export function getProducts(store) {
    return store.products;
}

export function getWarehouse(store) {
    return store.warehouse;
}

export function getStatus(store) {
    return store.status;
}

export function getUnsavedChanges(store) {
    return store.unsavedChanges;
}

export function getStockTakingsInProgress(store){
    return store.stockTakingsInProgress;
}



// WEBPACK FOOTER //
// ./src/scenes/Inventory/reducer/index.js